import { render, staticRenderFns } from "./approved-request.vue?vue&type=template&id=1b28c66d"
import script from "./approved-request.vue?vue&type=script&lang=js"
export * from "./approved-request.vue?vue&type=script&lang=js"
import style0 from "./approved-request.vue?vue&type=style&index=0&id=1b28c66d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports